export const ACCESS_ROLES = 'accessing Roles';
export const ACCESS_SUBJECT_ROLES = 'accessing Subject Roles';
export const ASSIGN_ROLES = 'assigning Roles';
export const DELETE_ROLES = 'deleting Roles';
export const IDP_ROLE_TOOLTIP = 'Role Mapped From Identity Provider';
export const LIAM = 'LIAM';
export const CUSTOMER_IDP = 'CustomerIdP';
export const EMPTY_LIST_TITLE = "It's empty here";
export const EMPTY_LIST_SUB_TITLE = "Select the item and transfer from the left side list";
export const AVAILABLE_ROLES = "Available Roles";
export const ASSIGNED_ROLES = "Assigned Roles";
export const ROLE_INFO_MESSAGE = "Transfer not more than 5 items at once.";
export const IDP_ROLES = "Roles Mapped from Identity Provider";
export const IDP_ROLES_SUBTITLE = "The following roles cannot be deleted";
